import script from "./AppLayoutPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLayoutPublic.vue?vue&type=script&setup=true&lang=js"

import "./AppLayoutPublic.vue?vue&type=style&index=0&id=0fe8db1a&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe8db1a"]])

export default __exports__